// extracted by mini-css-extract-plugin
module.exports = {"logo":"style_logo__pcq_D","disabled":"style_disabled__2dICP"};